<template>
  <div class="schedule-calendar-date" v-if="whetherShow">
    <div class="schedule-calendar-date-label" :class="[type,{chose:isChoseDay,today:isToday}]" @click="setDayTime">
      <template v-if="isToday">今</template>
      <template v-else>{{date.getDate()}}</template>
    </div>
    <span class="dot" v-if="showDot" :class="{next:isFuture}"></span>
  </div>
</template>
<script type="text/ecmascript-6">
  import {isSameDay} from './utils'
  import {getYearMonthDay} from 'common/js/getYearMonthDay'

  export default {

    props: {
      days: {
        type: Array
      },
      date: {
        type: Date,
        default: null,
      },
      type: String,
      whichWeek: Number,
      selectDay: Date,
      statusList: {
        type: Array,
        default: null,
      },
      openState: {
        type: Boolean,
        default: false,
      },
      selectWhichWeek: {
        type: Number,
      }
    },
    data() {
      return {
        volume: 0,
        expanded: false
      }
    },
    computed: {
      //确定是否进显示当前星期
      whetherShow() {
        if (this.openState) {
          return true;
        } else if (this.date && this.selectDay && this.days) {
          let selectWhichWeek;
          for (let i = 0; i < this.days.length; i++) {
            if (isSameDay(this.selectDay ,this.days[i].date)) {
              selectWhichWeek = Math.floor(i / 7);
            }
          }
          return selectWhichWeek == this.whichWeek;
        }
      },
      isToday() {
        return isSameDay(new Date(), this.date)
      },
      isChoseDay() {
        return isSameDay(this.selectDay, this.date)
      },
      showDot() {
        if (this.statusList == null || this.date == null) {
          return false;
        } else {
          for (let i = 0; i < this.statusList.length; i++) {
            // console.log(this.date.getMonth())
            if (getYearMonthDay(this.date) == this.statusList[i].date) {
              return true;
            }
          }
        }
        return false;
      },
      isFuture() {
        if (this.date == null) {
          return false;
        } else {
          //当前的日期
          let now = new Date(getYearMonthDay(new Date())).getTime();
          let item = new Date(getYearMonthDay(this.date)).getTime();
          if (item >= now) {
            return true;
          }
        }
        return false;
      },

    },
    methods: {
      calcVolume() {
        this.volume = Math.floor(this.$refs.details.clientHeight / 27)
      },
      setDayTime() {
        //点击日期，发送日期（Date形式）
        this.$emit('changeDay', this.date)
      },
      getYearMonthDay(rawDate) {
        let date = rawDate.date;
        let month = "0" + (date.getMonth() + 1);
        let day = "0" + date.getDate();

        return date.getFullYear() + '-' + month.substring(month.length - 2) + '-' + day.substring(day.length - 2);
      }

    },
    mounted() {
      // this.calcVolume()
      // window.addEventListener('resize', this.calcVolume)
    },
    destroyed() {
      // window.removeEventListener('resize', this.calcVolume)
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "~common/stylus/mixin"
  .schedule-calendar-date {
    float: left;
    width: 40px;
    height: 40px;
    line-height: 40px
    text-align: center;
    margin-right: 38px;
    position: relative
    cursor: pointer
    .dot {
      position: absolute
      left: 17px
      bottom: 2px
      display: inline-block
      width: 6px
      height: 6px
      background: #a5a5a5
      border-radius: 4px
      &.next {
        background: #ff6700
      }
    }
    &:nth-child(7n) {
      margin-right: 0;
    }
    .schedule-calendar-date-label {
      width: 100%
      height: 100%
      font-size: 14px;
      &.prev, &.next {
        color: #a5a5a5;
        &.chose {
          background: #ff6700;
          color: #fff;
          border-radius: 25px;
        }
      }
      &.current {
        color: #333
        &.chose {
          background: #ff6700;
          color: #fff;
          border-radius: 25px;
        }
      }
      &.today {
        color: #ff6700
        &.chose {
          background: #ff6700;
          color: #fff;
          border-radius: 25px;
        }
      }
      &.chose + .dot {
        background: #fff
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/calendar/dateCell.vue